export function durationSecondsComparator(valA: string, valB: string, nodeA: any, nodeB: any) {
  return nodeA.data.durationSeconds - nodeB.data.durationSeconds
}

export function ratingComparator(valA: string, valB: string, nodeA: any, nodeB: any) {
  return nodeA.data.rating - nodeB.data.rating
}

export function colorComparator(valA: string, valB: string) {
  if (!valA || !valB) return 0

  return valA.localeCompare(valB)
}

export function dateComparator(valA: string, valB: string) {
  return new Date(valA).getTime() - new Date(valB).getTime()
}
